import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '../constants';
import { ApiResponse } from '@/types';

export interface DashboardMetricsResponse {
  metrics: Array<{ id: string; title: string; value: number | string; change: number }>;
}

export interface ChartSeries {
  labels: string[];
  datasets: Array<{ label: string; data: number[] }>;
}

export const dashboardService = {
  async metrics(): Promise<DashboardMetricsResponse> {
    const result = await apiClient.get<ApiResponse<DashboardMetricsResponse>>(API_ENDPOINTS.DASHBOARD.METRICS, {
      authenticate: true,
    });
    return result.data ?? (result as unknown as DashboardMetricsResponse);
  },

  async charts(): Promise<ChartSeries> {
    const result = await apiClient.get<ApiResponse<ChartSeries>>(API_ENDPOINTS.DASHBOARD.CHARTS, {
      authenticate: true,
    });
    return result.data ?? (result as unknown as ChartSeries);
  },

  async activities<T = any[]>(): Promise<T> {
    const result = await apiClient.get<ApiResponse<T>>(API_ENDPOINTS.DASHBOARD.ACTIVITIES, {
      authenticate: true,
    });
    return result.data ?? (result as unknown as T);
  },
};


